<template>
  <main class="ciif-page" :lang="isEnglish ? 'en' : 'zh-CN'">
    <article class="article-content">
      <h1 class="article-title">{{ t('home.newslist.list.item10.title') }}</h1>
 
      <img
        class="article-image article-image--wide"
        :src="articleImageUrl5"
        alt="CIIF 生物制造专项奖"
      >

      <p><span v-for="(part, index) in article.intro" :key="index" :class="part.class">{{ part.text }}</span></p>

      <img class="article-image" :src="articleImageUrl2" alt="CIIF 生物制造专项奖">
      <p><span v-for="(part, index) in article.award" :key="index" :class="part.class">{{ part.text }}</span></p>

      <img class="article-image" :src="articleImageUrl1" alt="CIIF 生物制造专项奖">
      <p><span v-for="(part, index) in article.product" :key="index" :class="part.class">{{ part.text }}</span></p>

      <img class="article-image" :src="articleImageUrl3" alt="CIIF 生物制造专项奖">
      <p><span v-for="(part, index) in article.technology" :key="index" :class="part.class">{{ part.text }}</span></p>
      <p>{{ article.mission }}</p>

      <img class="article-image" :src="articleImageUrl4" alt="CIIF 生物制造专项奖">
      <p>{{ article.thanks }}</p>
    </article>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { locale, t } = useI18n();
const isEnglish = computed(() => locale.value === "en");
const articleImageUrl1 = "https://www.healthcode.com/media/CIIF2026/CIIF2026-1.jpg";
const articleImageUrl2 = "https://www.healthcode.com/media/CIIF2026/CIIF2026-2.jpg";
const articleImageUrl3 = "https://www.healthcode.com/media/CIIF2026/CIIF2026-3.jpg";
const articleImageUrl4 = "https://www.healthcode.com/media/CIIF2026/CIIF2026-4.jpg";
const articleImageUrl5 = "https://www.healthcode.com/media/CIIF2026/CIIF2026-5.jpg";
const blueBold = "blue-bold";
const bold = "bold-text";

const article = computed(() => isEnglish.value ? {
  intro: [
    { text: "The 26th China International Industry Fair (CIIF) has announced its award winners. " },
    { text: "Healthcode Bio", class: blueBold },
    { text: " received the CIIF Biomanufacturing Special Award for its independently developed biomanufacturing technology — ", class: blueBold },
    { text: "the D2Pi AutoLab intelligent automated laboratory system", class: blueBold },
    { text: ". It was honored with the ", class: blueBold },
    { text: "CIIF Biomanufacturing Special Award", class: blueBold },
    { text: ". Approved by the State Council, CIIF is one of China's most prestigious industrial exhibitions. This award is authoritative national recognition of Healthcode Bio's technological breakthroughs, industrialization capabilities, and innovation value." }
  ],
  award: [
    { text: "The " },
    { text: "CIIF Biomanufacturing Special Award", class: blueBold },
    { text: " focuses on the frontier of biomanufacturing. " },
    { text: "It recognizes exemplary companies that have achieved innovative breakthroughs in biosynthesis, green processes, and the translation of research into applications.", class: bold },
    { text: " The review involved multiple rigorous rounds, including an initial document review, expert assessment, and final review by the organizing committee." }
  ],
  product: [
    { text: "D2Pi AutoLab", class: blueBold },
    { text: " is a globally leading, integrated biomanufacturing Physical AI automated workstation, and the only one in China adapted to the complete cell-free protein synthesis process. It is a high-end scientific instrument for the intersecting fields of biomanufacturing, synthetic biology, and AI for Science. Its overall technical level is internationally advanced and domestically leading." }
  ],
  technology: [
    { text: "Building on Healthcode Bio's globally leading hundred-ton-scale cell-free protein synthesis manufacturing technology and the world's only reported ten-thousand-ton cell-free protein synthesis capacity, the company jointly validated the equipment with the National Facility for Protein Science Shanghai at the AI Protein Manufacturing Joint Laboratory. The team overcame four shortcomings of imported equipment: fragmented modules, low throughput, missing supporting systems, and supply-chain constraints. ", class: bold },
    { text: "Healthcode Bio independently developed the complete machine's mechanical structure, fluid control, AI-coupled algorithms, and dedicated consumables. The system supports target screening for innovative medicines, validation of novel AI-designed proteins, and high-throughput development of active ingredients and functional proteins. It fills a domestic gap in fully automated, integrated equipment for cell-free protein synthesis (CFPS), and aligns with the national strategy for domestic substitution of high-end biomanufacturing and AI equipment under the 14th and 15th Five-Year Plans. The instrument, supporting consumables, and software have all been tested by numerous leading universities and research institutes, with performance better than imported equipment in the same price range." }
  ],
  mission: "Deeply committed to biomanufacturing, Healthcode Bio continues to drive industrial upgrading through foundational technological innovation, overcome key challenges in the industrialization of bioprocesses, and empower the life and health industries with green biological solutions. The company is advancing biomanufacturing from the laboratory to large-scale implementation and helping foster new quality productive forces.",
  thanks: "This honor belongs to every member of Healthcode Bio's research and industrial teams. We also thank our industry partners, customers, and experts for their trust and support. With this recognition as a new beginning, Healthcode Bio will continue investing in biomanufacturing R&D, connecting innovation with industrialization, and working with partners across the industry to advance the high-quality development of China's biomanufacturing sector."
} : {
  intro: [
    { text: "第二十六届中国国际工业博览会（CIIF）重磅揭晓，" },
    { text: "康码科技", class: blueBold },
    { text: "凭借自主创新生物制造—", class: blueBold },
    { text: "D2Pi AutoLab 智能自动化实验室工作系统", class: blueBold },
    { text: "，荣膺", class: blueBold },
    { text: " CIIF 生物制造专项奖", class: blueBold },
    { text: "。作为经国务院批准、国内极具含金量的工业展会权威奖项，本次获奖是行业对康码科技技术突破、产业化能力与创新价值的国家级权威认可。" }
  ],
  award: [
    { text: "CIIF 生物制造专项奖", class: blueBold },
    { text: "聚焦生物制造前沿赛道，" },
    { text: "旨在表彰在生物合成、绿色工艺、成果转化等方向实现创新突破的标杆企业", class: bold },
    { text: "，评审历经材料初审、专家现场评审、组委会终审等多轮严格筛选，含金量十足。" }
  ],
  product: [
    { text: "D2Pi AutoLab", class: blueBold },
    { text: " 是全球领先的国内唯一适配完整无细胞蛋白合成工艺的一体化生物制造产业 Physical AI 自动化工作站，属于生物制造、合成生物学、AI4S 交叉领域高端科学成套仪器，整体技术水平达到国际先进、国内领先。" }
  ],
  technology: [
    { text: "依托康码科技全球领先百吨级，无细胞蛋白质合成量产技术，全球唯一万吨级无细胞蛋白质合成产能，联合国家蛋白质科学研究（上海）设施共建“AI蛋白质智造联合实验室”完成设备联合验证；突破进口设备模块化割裂、通量低、配套体系缺失、供应链受限四大短板，", class: bold },
    { text: "自主完成整机机械结构、流体控制、AI耦合算法、专用耗材全套研制；可完整支撑创新药靶点筛选、AI全新蛋白验证、活性原料、功能蛋白高通量开发，填补国产无细胞蛋白质合成（CFPS）全自动成套装备空白，符合“十四五”和”十五五”生物制造人工智能高端仪器设备国产替代政策战略导向。设备整机、配套耗材、软件系统均通过众多985高校、科研院所实测验证，性能优于同价位进口设备。" }
  ],
  mission: "深耕生物制造领域，康码科技坚持以底层技术创新驱动产业升级，攻克生物工艺产业化关键难题，以绿色生物方案赋能生命健康产业，推动生物制造技术从实验室走向规模化落地，助力培育新质生产力。",
  thanks: "这份荣誉，属于康码每一位科研与产业团队成员，也感谢行业伙伴、客户与专家的信任与支持。荣誉为序，步履不停。未来康码科技将持续加码生物制造技术研发，打通创新成果产业化链路，携手产业链各方，共同推动中国生物制造产业高质量发展！"
});
</script>

<style scoped>
.ciif-page {
  width: 100%;
  min-height: 100vh;
  padding: 8rem 0 4rem;
  background: #fff;
  color: #000;
}

.article-content {
  width: 100%;
  max-width: 677px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  font-size: 16px;
  line-height: 1.8;
  overflow-wrap: break-word;
}

.article-content p {
  margin: 1em 0;
  color: #222;
  text-align: justify;
}

.article-title {
  margin: 0.75rem 0 2rem;
  color: #222;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.45;
}

.article-image {
  display: block;
  width: 100%;
  height: auto;
  margin: 1.5rem auto;
}

.blue-bold {
  color: #3daad6;
  font-weight: 700;
}

.bold-text {
  font-weight: 700;
}

@media (max-width: 640px) {
  .ciif-page {
    padding-top: 7rem;
  }

  .article-content {
    padding: 0 16px;
    font-size: 16px;
  }

  .article-title {
    font-size: 22px;
  }

}
</style>